const TOKEN_KEY = "w1Token";
const LEGACY_KEYS = [TOKEN_KEY, "token", "w1TokenAddress", "w1TokenChain", "w1TokenExpireAt"];
let tokenEpoch = 0;

function normalizeToken(raw) {
  return String(raw || "").trim().replace(/^Bearer\s+/i, "");
}

export function getSessionToken() {
  return normalizeToken(sessionStorage.getItem(TOKEN_KEY));
}

export function getTokenEpoch() {
  return tokenEpoch;
}

export function storeSessionToken(raw, expectedEpoch = tokenEpoch) {
  if (expectedEpoch !== tokenEpoch) return "";
  const token = normalizeToken(raw);
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  return token;
}

// Older builds persisted credentials across browser sessions. Remove those copies
// before any API or WebSocket request can reuse them.
export function clearLegacyTokenStorage() {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
  document.cookie = `${TOKEN_KEY}=; path=/; Max-Age=0; SameSite=Lax`;
}

export function clearSessionToken() {
  tokenEpoch += 1;
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem("token");
  clearLegacyTokenStorage();
}
